import { configureStore } from "@reduxjs/toolkit";
import homeReducer from "./HomeSlice";
import getAllTestReducer from "./GetAllTestSlice";
import getPackageDetailReducer from "./GetPackageDetailSlice";
import authReducer from "./authSlice";

const store = configureStore({
  reducer: {
    homeReducer,
    getPackageDetailReducer,
    getAllTestReducer,
    auth: authReducer,
  },
});

export default store;
